// import APIs
import { BONUS_PERIODS, BONUS_PERIODS_RESTRICTED } from 'RestAPIs/endpoints';

// import external libraries
import axios from 'axios';

// import types
import { EmployeeBonusesResponse, GetEmployeeBonusesProps } from './types';

export const getEmployeeBonuses = ({
  employeeId,
  startDate,
  endDate,
  buhTypeSvc,
  isEmployeePortal = false
}: GetEmployeeBonusesProps) => {
  const BONUS_PERIODS_URL = isEmployeePortal
    ? BONUS_PERIODS_RESTRICTED
    : BONUS_PERIODS;

  return axios.get<EmployeeBonusesResponse>(BONUS_PERIODS_URL, {
    pathParams: { employeeId, startDate, endDate, buhTypeSvc }
  });
};
